import { http, HttpResponse } from 'msw';

import { Offers } from '../../types/OfferTypes';

const offersResponse: Offers = {
    offers: [
        {
            offerId: '123456',
            offerType: 'CASH',
            status: 'APPROVED',
            riskColor: 'GREEN',
            approved: {
                amount: 50000,
                currency: 'NOK',
            },
            preliminaryDisbursement: {
                amount: 0,
                currency: '',
            },
            requiredConsolidation: {
                amount: 0,
                currency: '',
            },
            monthlyInstallment: {
                amount: 1200,
                currency: '',
            },
            tenor: {
                months: 35,
                years: 3,
                yearsMonthsRemainder: -1,
            },
            effectiveInterest: {
                percent: 25.2,
                decimal: 0.252,
            },
            nominalInterest: {
                percent: 25.2,
                decimal: 0.252,
            },
            existingLoan: undefined,
            adminFee: {
                name: '',
                feeCode: '',
                labelCode: '',
                amount: 0,
                currency: '',
            },
            setupFee: {
                name: '',
                feeCode: '',
                labelCode: '',
                amount: 0,
                currency: '',
            },
            totalLoanCost: {
                amount: 0,
                currency: '',
            },
            totalRepayment: {
                amount: 0,
                currency: '',
            },
        },
        {
            offerId: '231233',
            offerType: 'MAX_CONSOLIDATION',
            status: 'APPROVED',
            riskColor: 'GREEN',
            approved: {
                amount: 80000,
                currency: 'NOK',
            },
            preliminaryDisbursement: {
                amount: 10000,
                currency: 'NOK',
            },
            requiredConsolidation: {
                amount: 60000,
                currency: '',
            },
            monthlyInstallment: {
                amount: 1200,
                currency: '',
            },
            tenor: {
                months: 12,
                years: 1,
                yearsMonthsRemainder: 0,
            },
            effectiveInterest: {
                percent: 25.2,
                decimal: 0.252,
            },
            nominalInterest: {
                percent: 25.2,
                decimal: 0.252,
            },
            existingLoan: undefined,
            adminFee: {
                name: '',
                feeCode: '',
                labelCode: '',
                amount: 0,
                currency: '',
            },
            setupFee: {
                name: '',
                feeCode: '',
                labelCode: '',
                amount: 0,
                currency: '',
            },
            totalLoanCost: {
                amount: 0,
                currency: '',
            },
            totalRepayment: {
                amount: 0,
                currency: '',
            },
            consolidations: [
                {
                    internalId: '1234',
                    creditorName: 'Banana Bank',
                    currentBalance: {
                        amount: 20000,
                        currency: 'NOK',
                    },
                    nominalInterestRate: 13.3,
                    accountType: 'CREDIT_FACILITY',
                    tenor: 36,
                    applicantType: 'MAIN',
                },
                {
                    internalId: '4321',
                    creditorName: 'Beluga Bank',
                    currentBalance: {
                        amount: 20000,
                        currency: 'NOK',
                    },
                    nominalInterestRate: 23.7,
                    accountType: 'REPAYMENT_LOANS',
                    tenor: 24,
                    applicantType: 'MAIN',
                    consolidationType: 'PARTIAL',
                    consolidationAmount: {
                        amount: 10000,
                        currency: 'NOK',
                    },
                },
                {
                    internalId: '6566',
                    creditorName: 'Faluja Bank',
                    currentBalance: {
                        amount: 20000,
                        currency: 'NOK',
                    },
                    nominalInterestRate: 10.7,
                    accountType: 'REPAYMENT_LOANS',
                    tenor: 12,
                    applicantType: 'CO',
                },
                {
                    internalId: '12345',
                    creditorName: 'YAHA Bank',
                    currentBalance: {
                        amount: 27000,
                        currency: 'NOK',
                    },
                    nominalInterestRate: 10.7,
                    accountType: 'CHARGE_CARDS',
                    tenor: 12,
                    applicantType: 'CO',
                },
            ],
        },
    ],
};

export const getOffersHandlers = [
    http.get('*/api/cl_loanapp_proxy_service/v1/:countryCode/offers/:arn', async () => {
        return HttpResponse.json(offersResponse);
    }),
];
